/**
 * Légende du calendrier
 * Affiche les différents types d'événements avec leurs couleurs
 */

import { Building, CalendarDays, Users } from 'lucide-react';

interface LegendItem {
  type: string;
  label: string;
  color: string;
  accentColor: string;
  icon: React.ReactNode;
}

export function CalendarLegend() {
  const legendItems: LegendItem[] = [
    {
      type: 'booking_coworking',
      label: 'Coworking',
      color: '#00758d',
      accentColor: '#00303c',
      icon: <Users size={16} color="#ffffff" />,
    },
    {
      type: 'booking_meeting',
      label: 'Salles de réunion',
      color: '#00303c',
      accentColor: '#00758d',
      icon: <Building size={16} color="#ffffff" />,
    },
    {
      type: 'booking_office',
      label: 'Bureaux',
      color: '#1976d2',
      accentColor: '#0d47a1',
      icon: <Building size={16} color="#ffffff" />,
    },
    {
      type: 'calendar_event',
      label: 'Événements SING',
      color: '#8E0B56',
      accentColor: '#6b0942',
      icon: <CalendarDays size={16} color="#ffffff" />,
    },
  ];

  return (
    <div
      style={{
        background: 'white',
        borderRadius: '16px',
        padding: '24px',
        boxShadow: '0 4px 12px rgba(0,48,60,0.08)',
        marginBottom: '24px',
      }}
    >
      <h3
        style={{
          fontSize: '16px',
          fontWeight: 700,
          color: '#00303c',
          marginBottom: '16px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <div
          style={{
            width: '32px',
            height: '32px',
            borderRadius: '8px',
            background: 'rgba(0, 117, 141, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CalendarDays size={18} color="#00758d" />
        </div>
        Légende
      </h3>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '12px',
        }}
      >
        {legendItems.map((item) => (
          <div
            key={item.type}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px',
              borderRadius: '10px',
              background: '#f8f9fa',
              border: '2px solid rgba(0,117,141,0.1)',
            }}
          >
            <div
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '8px',
                background: `linear-gradient(135deg, ${item.color} 0%, ${item.accentColor} 100%)`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                flexShrink: 0,
              }}
            >
              {item.icon}
            </div>
            <div>
              <div
                style={{
                  fontSize: '14px',
                  fontWeight: 600,
                  color: '#00303c',
                }}
              >
                {item.label}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div
        style={{
          marginTop: '16px',
          padding: '12px 16px',
          borderRadius: '10px',
          background: 'rgba(0, 117, 141, 0.05)',
          border: '1px solid rgba(0, 117, 141, 0.15)',
        }}
      >
        <p
          style={{
            fontSize: '13px',
            color: 'rgba(0,48,60,0.7)',
            lineHeight: 1.6,
          }}
        >
          <strong style={{ color: '#00758d' }}>Info :</strong> Cliquez sur un événement pour voir ses détails complets.
          Les réservations affichées sont celles confirmées ou payées.
        </p>
      </div>
    </div>
  );
}
